import { Errors } from '../enums/errors';
import { StorageError } from '../error/storage';
export class VideoResolve {
    constructor(transport) {
        this._transport = transport;
    }
    static create(transport) {
        return new VideoResolve(transport);
    }
    _parseManifestResponse(response) {
        if (response.status !== 200) {
            const error = new StorageError(Errors.STORAGE_VIDEO_MANIFEST_FAILED, `Video manifest request failed with status ${response.status}`);
            error.status = response.status;
            return Promise.reject(error);
        }
        return Promise.resolve(response.body);
    }
    getInitSegmentURLs(baseURL, initTemplate, audioProfile, videoProfile) {
        const audioURL = baseURL +
            initTemplate
                .replace('{{profile_id}}', audioProfile.id)
                .replace('{{file_type}}', audioProfile.file_type);
        const videoURL = baseURL +
            initTemplate
                .replace('{{profile_id}}', videoProfile.id)
                .replace('{{file_type}}', videoProfile.file_type);
        return {
            audio: audioURL,
            video: videoURL,
            // Logged URLs
            audioLogging: audioURL,
            videoLogging: videoURL,
        };
    }
    getSegmentURLs(baseURL, segmentTemplate, position, audioProfile, videoProfile) {
        const audioURL = baseURL +
            segmentTemplate
                .replace('{{profile_id}}', audioProfile.id)
                .replace('{{file_type}}', audioProfile.file_type);
        const videoURL = baseURL +
            segmentTemplate
                .replace('{{profile_id}}', videoProfile.id)
                .replace('{{file_type}}', videoProfile.file_type);
        return {
            audio: audioURL.replace('{{segment_timestamp}}', position.toString()),
            video: videoURL.replace('{{segment_timestamp}}', position.toString()),
            // Logged URLs
            audioLogging: audioURL,
            videoLogging: videoURL,
        };
    }
    // TODO to fix Promise<any>
    getManifest(fileId) {
        const path = '@webgate/manifests/v6/json/sources';
        const endpoint = `${path}/${fileId}/options/supports_drm`;
        return this._transport
            .request(endpoint, {
            authorize: true,
            responseType: 'json',
            retry: {
                condition: (response, _StatusFamily) => response.getStatusFamily() !== _StatusFamily.SUCCESS,
            },
        })
            .then(this._parseManifestResponse);
    }
}
//# sourceMappingURL=video_resolve.js.map